import type { FeedbackMessages } from './en';

const de: FeedbackMessages = {
  qualified: {
    title: 'Vielen Dank für Ihre Teilnahme an dieser Studie!',
    text: 'Sie können das Browserfenster nun schließen.\n\nWir hoffen, Sie bald wiederzusehen.',
  },
  quotaFull: {
    title: 'Diese Studie ist geschlossen',
    text: 'Vielen Dank für Ihr Interesse an unserer Studie.\n\nLeider haben wir bereits alle benötigten Antworten erhalten.\n\nWir hoffen, Sie in einer unserer zukünftigen Studien begrüßen zu dürfen!',
  },
  terminated: {
    title: 'Vielen Dank für Ihr Feedback!',
    text: 'Wir hoffen, Sie bald in einer unserer zukünftigen Studien wiederzusehen. Bis dahin wünschen wir Ihnen einen schönen Tag.\n\nBitte schließen Sie dieses Browserfenster.',
  },
  mismatch: {
    title: 'Vielen Dank für Ihr Interesse',
    text: 'Leider gehören Sie nicht zur Zielgruppe dieser speziellen Studie.\n\nSie können diese Seite nun schließen.',
  },
  error: {
    title: 'Wir können Ihre Anfrage derzeit nicht bearbeiten',
    linkProblemDetailed:
      'Bei dem von Ihnen aufgerufenen Link ist ein Problem aufgetreten. Bitte überprüfen Sie, ob der Link in der Adresszeile mit dem Ihnen mitgeteilten Link übereinstimmt, und versuchen Sie es erneut.',
    linkProblemGeneric:
      'Bei dem von Ihnen aufgerufenen Link ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.',
    contactPerson:
      'Sollte das Problem weiterhin bestehen, informieren Sie bitte die Person, von der Sie den Link erhalten haben, über dieses Problem.',
  },
};

export default de;
